import React, { useMemo, useState, useEffect } from "react";
import TableComponent from "../Common/TableComponent";
import { Link, useLocation } from "react-router-dom";
import FilterComponent from "../Common/FilterComponent";
import TopHeader from "../Common/TopHeader";
import { ButtonGroup, Container, ToggleButton } from "react-bootstrap";
import TooltipPositioned from "../Tooltip/TooltipPositioned";
import { PhoneNumberFormatter, CheckPropertyExistOrNot, DisplayToaster } from "../../core/services/sharedService";
import { GetApiMethod } from "../../core/services/apiService";
import { useAppSelector } from "../../core/redux/hooks";
import constant from "../../core/constant";
import AppModal from "../AppModal/AppModal";
import DataTable from "react-data-table-component";


const LocationList = () => {

    const [data, setData] = useState<any>([]);
    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [namess, setNamess] = useState();
    const [action, setAction] = useState();
    const [textvisible, setTextvisible] = useState(false);
    const [deleteMsg] = useState<any>();
    const [deleteMsgtimeout] = useState(false);
    const [showLoader, setShowLoader] = useState(true);
    const [statusFilter, setStatusFilter] = useState<string>("active");
    const [showQrCodeModel, setShowQrCodeModel] = useState<{ show: boolean, qrCodeUrl: string | undefined, locationName: string | undefined }>({ show: false, qrCodeUrl: undefined, locationName: undefined });

    const statusOptions = [
        { name: "Active", value: "active" },
        { name: "Inactive", value: "inactive" },
        { name: "All", value: "all" },
    ];

    const locationUrl = "tenant/location-crud";
    const location = useLocation();

    let LoginUserDetails = useAppSelector((state) => state.auth.users);

    const copyme = (copytext: any) => {
        let textField = document.createElement('textarea');
        textField.innerText = copytext;
        document.body.appendChild(textField)
        textField.select()
        document.execCommand('copy')
        textField.remove();
        DisplayToaster("bg-success", "Video call URL copied to clipboard!");
    }
    useEffect(() => {
        GetApiMethod(locationUrl).then((res) => {
            setShowLoader(false);
            setData(res.data.data);
        });
        GetApiMethod("tenant/agent-crud").then((res) => {
            setShowLoader(false);
        });
        if (location.state !== null) {
            setNamess(location.state.name);
            setAction(location.state.action);
            setTextvisible(true);
            setTimeout(() => {
                setTextvisible(false);
            }, 10000);
        }
    }, []);

    const columns: any = [
        {
            name: 'Name',
            selector: (row: any) => row['name'],
            cell: (row: any) => (
                <div>
                    {TooltipPositioned({ 'placement': 'top', 'item': CheckPropertyExistOrNot(row, 'name') })}
                </div>
            ),
            sortable: true,
            style: {
                lineHeight: '1.4',
                paddingTop: '3px',
                paddingBottom: '3px'
            }
        },
        {
            name: 'Address',
            selector: (row: any) => row['address'],
            cell: (row: any) => (
                <div>
                    {TooltipPositioned({ 'placement': 'top', 'item': CheckPropertyExistOrNot(row, 'address') })}
                </div>
            ),
            sortable: true,
        },
        {
            name: 'Twilio Number',
            selector: (row: any) => row['contact'],
            cell: (row: any) => (
                <div>
                    {/* {PhoneNumberFormatter(String((row.contact)), String(row.contact).length)} */}
                    {TooltipPositioned({
                        'placement': 'top', 'item':
                            CheckPropertyExistOrNot(row, 'contact') !== "-"
                                ?
                                PhoneNumberFormatter(CheckPropertyExistOrNot(row, 'contact').toString().slice(1), CheckPropertyExistOrNot(row, 'contact').toString().slice(1).length)
                                :
                                "-"
                    })}
                </div>
            ),
            sortable: true,
        },
        {
            name: 'Agent Unavailable Forwarding Number',
            selector: (row: any) => row['call_forward'],
            cell: (row: any) => (
                <div>
                    {TooltipPositioned({
                        'placement': 'top', 'item':
                            CheckPropertyExistOrNot(row, 'call_forward') !== "-"
                                ?
                                PhoneNumberFormatter(row.call_forward.toString().slice(1), row.call_forward.toString().slice(1).length)
                                :
                                "-"
                    })}
                </div>
            ),
            sortable: true,
        },
        {
            name: 'Customer Facing Phone Number',
            selector: (row: any) => row['customer_contact'],
            cell: (row: any) => (
                <div>
                    {(CheckPropertyExistOrNot(row, 'customer_contact') !== "-") ? TooltipPositioned({ 'placement': 'top', 'item': PhoneNumberFormatter(row.customer_contact.toString().slice(1), row.customer_contact.toString().slice(1).length) }) : "-"}
                </div>
            ),
            sortable: true,
        },
        {
            name: 'State',
            selector: (row: any) => row['state'],
            cell: (row: any) => (
                <div>
                    {TooltipPositioned({ 'placement': 'top', 'item': CheckPropertyExistOrNot(row, 'state') })}
                </div>
            ),
            sortable: true,
        },
        {
            name: 'City',
            selector: (row: any) => row['city'],
            cell: (row: any) => (
                <div>
                    {TooltipPositioned({ 'placement': 'top', 'item': CheckPropertyExistOrNot(row, 'city') })}
                </div>
            ),
            sortable: true,
        },
        {
            name: 'Status',
            // selector: (row: any) => ((CheckPropertyExistOrNot(row, 'isActive') === true ? "Active" : (CheckPropertyExistOrNot(row, 'isActive') === false ? "Inactive" : "-"))),
            selector: (row: any) => ('isActive' in row ? (row.isActive ? "Active" : "Inactive") : "-"),
            sortable: true,
        },
        {
            name: 'Primary Agent',
            selector: (row: any) => row['name'],
            cell: (row: any) => (
                <div>
                    {TooltipPositioned({
                        'placement': 'top', 'item':
                            CheckPropertyExistOrNot(row, 'name', 'primary_agent') !== "-"
                                ?
                                `${CheckPropertyExistOrNot(row, 'name', 'primary_agent')}(${CheckPropertyExistOrNot(row, 'email', 'primary_agent')})`
                                :
                                "-"
                    })}
                    {/* { ('primary_agent' in row && 'name' in row.primary_agent && 'email' in row.primary_agent )? TooltipPositioned({ 'placement': 'top', 'item': row.primary_agent.name + '(' + row.primary_agent.email + ')' }):"-"} */}
                </div>
            ),
            sortable: true,
            style: {
                lineHeight: '1.4',
                paddingBottom: '3px',
                paddingTop: '3px'
            }
        },
        {
            name: 'Secondary Agent',
            selector: (row: any) => row['name'],
            cell: (row: any) => (
                <div>
                    {TooltipPositioned({
                        'placement': 'top', 'item':
                            CheckPropertyExistOrNot(row, 'name', 'secondary_agent') !== "-"
                                ?
                                `${CheckPropertyExistOrNot(row, 'name', 'secondary_agent')}(${CheckPropertyExistOrNot(row, 'email', 'secondary_agent')})`
                                :
                                "-"
                    })}
                    {/* {(row.hasOwnProperty('secondary_agent') && row.secondary_agent!== null && 'name' in row.secondary_agent && 'email' in row.secondary_agent ) ? TooltipPositioned({ 'placement': 'top', 'item': row.secondary_agent?.name + '(' + row.secondary_agent?.email + ')' }) : "-"} */}
                </div>
            ),
            sortable: true,
            style: {
                lineHeight: '1.4',
                paddingBottom: '3px',
                paddingTop: '3px'
            }
        },
        {
            name: 'Actions',
            cell: (row: any) => (
                <>
                    <div>
                        <Link to={constant.LOCATION_EDIT} state={{
                            id: row._id, name: row.name, address: row.address, contact: row.contact, call_forward: row.call_forward, state: row.state, city: row.city, zipCode: row.zipCode, primaryagent: row.primary_agent?.name, secagent: row.secondary_agent?.name, primaryagent_id: row.primary_agent?._id, secagent_id: row.secondary_agent?._id, presentation: row.presentation,
                            footer_image: row.footer_image, background_color: row.background_color, customer_contact: row.customer_contact, is_active: row.isActive, activeHrs: row.activeHrs, callForwardActiveHrs: row.callForwardActiveHrs,
                            enableCallTree: row.enableCallTree, callTreeData: row.callTreeData, callTreeInformationToPlay: row.callTreeInformationToPlay, callTreeAudioFile: row.callTreeAudioFile, timeZone: row.timeZone,
                            enableVoiceMail: row.enableVoiceMail, sendRecording: row.sendRecording, mailToAgents: row.mailToAgents, voiceMailEmail: row.voiceMailEmail, voicemailAudio: row.voicemailAudio,
                            hummingBirdOrSSM: row.hummingBirdOrSSM, pms_name: row.pms_name, ssm_user_id: row.ssm_user_id, ssm_password: row.ssm_password, ssm_base_url: row.ssm_base_url, application_id: row.application_id, company_id: row.company_id, storageapi_key: row.storageapi_key,
                            kiosk_home_screen_logo:row.kiosk_home_screen_logo,
                            gateAccess: row.gateAccess, accessControlType: row.accessControlType, accessHours: row.accessHours, unitTypesOffered: row.unitTypesOffered, onSiteOffice: row.onSiteOffice, billingType: row.billingType, facilityCheatSheetLink: row.facilityCheatSheetLink,
                            customLocationFields: row.customLocationFields
                        }}><i className="bi bi-pencil-square text-primary m-1" style={{ fontSize: 24 }}></i></Link>
                        {/* <i className="bi bi-trash-fill text-danger m-1 hover cursor-pointer" onClick={(e) => { handleDelete(e, row._id, row.name) }} style={{ fontSize: 24 }}></i> */}
                    </div>

                    <div>
                        <i className="bi bi-eye-fill text-primary m-1" style={{ fontSize: 24, cursor: "pointer" }} onClick={() => { setShowQrCodeModel({ show: true, qrCodeUrl: row.qr_code, locationName: row.name }) }}></i>
                    </div>
                    <span className="cursor-pointer" title={"Copy video call URL"} onClick={(e) => { copyme(row.video_call_url) }} >{<i className="bi bi-link-45deg text-primary m-1" aria-hidden="true" style={{ fontSize: 24 }}></i>}</span>
                </>
            )
        },
    ];

    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }
        };

        return (
            <div className="status-filter-wrapper">
                <ButtonGroup className="status-filter-group">
                    {statusOptions.map((option) => (
                        <ToggleButton
                            key={option.value}
                            id={`location-status-filter-${option.value}`}
                            type="radio"
                            name="locationStatusFilter"
                            value={option.value}
                            checked={statusFilter === option.value}
                            onChange={(e) => setStatusFilter(e.currentTarget.value)}
                            className="status-filter-btn"
                        >
                            {option.name}
                        </ToggleButton>
                    ))}
                </ButtonGroup>
                <FilterComponent
                    onFilter={(e: any) => setFilterText(e.target.value)}
                    onClear={handleClear}
                    filterText={filterText}
                />
            </div>
        );
    }, [filterText, resetPaginationToggle, statusFilter]);


    const printQrCodeImage = React.useCallback((URL: string | undefined) => {

        if (URL) {
            const qrCode = window.open("about:blank", "_new")!;
            qrCode.document.open();
            qrCode.document.write("<html><head><script>function step1(){setTimeout('step2()', 10);} function step2(){window.print();window.close()}\n" +
                "</script><title>QR Code</title></head><body onload='step1()'> <div style={{ textAlign: 'center' }}><img src='" + URL + "' /></div></body></html>");
            qrCode.document.close();
            setShowQrCodeModel({ show: false, qrCodeUrl: undefined, locationName: undefined });
        }
    }, [])


    const filteredItems = data.filter((item: any) =>
        statusFilter === "all" ? true
            : statusFilter === "active" ? item.isActive === true
            : item.isActive === false
    ).filter(
        (item: any) =>
            JSON.stringify([
                item.name, item.address, item.contact, item.call_forward, ('customer_contact' in item && item.customer_contact),
                item.state, item.city, (item.isActive ? "Active" : "Inactive"), item.primary_agent?.name, item.primary_agent?.email,
                item.secondary_agent?.name, item.secondary_agent?.email
            ])
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );
    const allDays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

    const workHrsFormat = (data: string) => {
        let splitData = data?.split(",");
        return splitData?.map((item: any, index: number) => (
            <>
                <span key={index}>{item.replace('-', ' To ')}</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </>
        ))
    }

    const ExpandedComponents = React.useCallback(({ data }: any) => {
        // console.log(data, '---------------->data');
        return (
            <div>
                <table className="table table-bordered m-3" style={{ width: '100%', maxWidth: '70%' }} >
                    <thead className="table-primary text-center">
                        <tr>
                            <td><b>Day Wise</b></td>
                            <td><b>Kiosk Work Hours</b></td>
                            <td><b>Call Center Work Hours</b></td>
                        </tr>
                    </thead>
                    <tbody>
                        {allDays.map((item: any, index: number) => (
                            <tr key={index}>
                                <td><b>{item[0].toUpperCase() + item.slice(1)}</b></td>
                                <td className="text-center">{data.activeHrs?.days[item]?.holiday ? "Holiday" : workHrsFormat(data.activeHrs?.days[item]?.time)}</td>
                                <td className="text-center">{data.callForwardActiveHrs?.days[item]?.holiday ? "Holiday" : workHrsFormat(data.callForwardActiveHrs?.days[item]?.time)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        )
    }, [])

    return (
        <>
            <Container fluid>
                <div className="text-center text-success mt-3">
                    <h6>{textvisible && (action === "edit" ? namess && "Location " + namess + " details updated successfully" : namess && "Location " + namess + " created successfully")}</h6>
                </div>
                <TopHeader heading="Locations" to={constant.LOCATION_CREATE}
                    action={LoginUserDetails.role === "vendor_admin" ? "Request Location" : "Add"} className="bi bi-plus-lg" id="location-create"
                    ToasterMessage="You must create at least one Agent to create Locations."
                    showPopup={LoginUserDetails.role === "vendor_admin" ? false : undefined} />

                <DataTable
                    progressPending={showLoader}
                    columns={columns}
                    data={filteredItems}
                    pagination
                    paginationRowsPerPageOptions={[5, 10, 15, 20]}
                    highlightOnHover
                    subHeader
                    persistTableHead
                    subHeaderComponent={subHeaderComponent}
                    expandableRows={true}
                    expandableRowsComponent={ExpandedComponents}
                    expandOnRowClicked


                />

                {/* <TableComponent data={data} columns={columns} subHeaderComponent={subHeaderComponent} filteredItems={filteredItems} deleteMsg={deleteMsg} deleteMsgtimeout={deleteMsgtimeout} showLoader={showLoader} /> */}
            </Container>
            {
                (showQrCodeModel.show && showQrCodeModel.qrCodeUrl) ?
                    <AppModal
                        title={`${showQrCodeModel.locationName} QR Code`}
                        bodyText={"Scan to connect with agent"}
                        children={
                            <div style={{ textAlign: "center" }}>
                                <img alt="Error" src={showQrCodeModel.qrCodeUrl}></img>
                            </div>
                        }
                        showCloseButton={true}
                        closeButtonEventEmitter={() => { setShowQrCodeModel({ show: false, qrCodeUrl: undefined, locationName: undefined }); }}
                        primaryButtonLabel={"Save"}
                        primaryButtonEventEmitter={() => { window.open(showQrCodeModel.qrCodeUrl, '_blank'); }}
                        secondaryButtonLabel={"Print"}
                        secondaryButtonEventEmitter={() => { printQrCodeImage(showQrCodeModel.qrCodeUrl); }}
                        stayAppear={true}
                    ></AppModal>
                    :
                    <></>

            }

        </>
    )
}

export default LocationList;